import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Form, Input, Field, CnIcon, CnButton, Message, CascaderSelect, CnMessage, Grid, CnForm, CnAsyncSelect, } from '@alife/cn-ui';
import i18n, { useI18n } from '@alife/panda-i18n';
import { getBizTypeTrees, createCase, getSnapshotPermission, saveSnapshotPermission, getCompanyList, } from 'src/services';
import UrlParser from 'fast-url-parser';
import { logCustom, logError } from 'src/utils/tracker';
import { accountTypeSearchMap, Env, workOrderUrlMap } from 'src/utils/const';
import Result from 'src/view/components/result';
import Header from '../header';
import Upload from './upload';
const { Row, Col } = Grid;
import './index.scss';
import { initXReplay, startSnapshot } from 'src/utils/xreplay';
import { getDefer, getFormValue } from 'src/utils';
import { useWorkOrderForm } from 'src/hooks/work-order';
import RichEditor from '../rich-editor';
let recordNum = 0;
export function goGocPage(url) {
    const urlParam = UrlParser.parse(url);
    console.log('urlParam', urlParam);
    let newUrl = `${url}${urlParam.query ? '&' : '?'}referrerUrl=${encodeURIComponent(location.href)}`;
    window.open(newUrl);
}
export function getWordOrderUrl(param) {
    const { env, userSystem, linkCode, path = '/list' } = param;
    let url = workOrderUrlMap[env] || workOrderUrlMap[Env.prod];
    if (userSystem !== 'cainiao') {
        url = url.replace('.cainiao.', '.cainiao-inc.');
    }
    const lang = i18n.getLang() || 'zh-CN';
    const accountStr = accountTypeSearchMap[userSystem];
    const newUrl = `${url}${path}?linkCode=${linkCode}&lang=${lang}${accountStr ? `&${accountStr}` : ''}`;
    return newUrl;
}
export function gotoWorkOrder(param) {
    window.top?.open(getWordOrderUrl(param));
}
const langCode = i18n.getLang();
function parseTreeSelect(data) {
    return data.map((m) => {
        if (m['children']) {
            m['children'] = parseTreeSelect(m['children']);
        }
        return {
            ...m,
            selectable: !m['children'],
            label: m['name'],
            fullName: m['nameFullPath'],
            value: m['id'],
        };
    });
    // .slice(0,1);
}
const screenshotKey = 'screenshot';
export default function Feedback(props) {
    const uploadRef = useRef();
    const { onBack, userId, onClose, userSystem, userName, config, panelCode, startRecord, extraInfo, } = props;
    const { appName, xlPanelConfigDTOList, code } = config;
    const field = Field.useField();
    const [bizTree, setBizTree] = useState([]);
    const [problemType, setProblemType] = useState({});
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [snapshotVisible, setSnapshotVisible] = useState(false);
    const [snapTipVisible, setSnapTipVisible] = useState(false);
    const [snapAuthFlag, setSnapAuthFlag] = useState(false);
    const authRefRef = useRef();
    const $i18n = useI18n();
    const find = xlPanelConfigDTOList?.find((m) => m.panelConfigCode === 'feedback');
    const linkCode = props.linkCode;
    const feedbackCode = linkCode || find?.data?.baseCaseLinkCode;
    const hasCaseType = linkCode ? false : find?.data?.caseType === 'baseGocCase';
    const gocCaseUrl = find?.data?.gocCaseUrl;
    // const showSelectBusiness = useMemo(() => {
    //   return true;
    //   try {
    //     return !!(store.get('custom-help-center-config') || { }).showSelectBusiness?.(panelCode);
    //   } catch (error) {
    //     console.error(error, '获取选择商业名称逻辑失败')
    //   }
    //   return true;
    // }, []);
    // 截屏或者录屏是否授权 如果未授权 则 提示用户授权
    const snapAuth = useCallback(async () => {
        if (!snapAuthFlag) {
            const res = await getSnapshotPermission({
                userId,
                accountType: userSystem,
            });
            if (!res || !res[screenshotKey]) {
                setSnapTipVisible(true);
                const defer = getDefer();
                authRefRef.current = defer;
                // @ts-ignore
                await defer.promise;
            }
            else {
                setSnapAuthFlag(true);
            }
        }
    }, [userId, userSystem, snapAuthFlag]);
    // 授权方法 如果授权则保存授权标识
    const agreeAuth = useCallback(async (flag) => {
        if (!flag) {
            setSnapTipVisible(false);
        }
        else {
            if (!snapAuthFlag) {
                await saveSnapshotPermission({
                    userId,
                    accountType: userSystem,
                    type: screenshotKey,
                });
            }
            setSnapTipVisible(false);
            setSnapAuthFlag(true);
            authRefRef.current?.resolve();
        }
    }, [userId, userSystem, snapAuthFlag]);
    useEffect(() => {
        initXReplay();
        logCustom('EXP_feedback', find?.data, panelCode);
    }, []);
    const [isSubmit, setIsSubmit] = useState(false);
    const onFeedSubmit = () => {
        field.validate(async (error, values) => {
            if (!error) {
                let extendInfo = formInstance?.values
                    ? getFormValue(formInstance)
                    : undefined;
                if (extendInfo || values.merchantCnMemberId) {
                    extendInfo = {
                        merchantCnMemberId: values.merchantCnMemberId,
                        ...extendInfo,
                        ...extraInfo,
                    };
                    if (values.merchantCnMemberId) {
                        delete values.merchantCnMemberId;
                    }
                }
                if (formInstance) {
                    await formInstance.validate();
                }
                // @ts-ignore
                const files = uploadRef?.current?.getValue();
                const joinTitle = appName + '-' + userName + '的' + problemType?.label + '工单';
                setIsSubmit(true);
                try {
                    const res = await createCase({
                        ...values,
                        sourceId: code,
                        title: joinTitle,
                        linkCode: feedbackCode,
                        userId,
                        extendInfo,
                        panelCode,
                        accountType: userSystem,
                        bizTypeId: problemType?.value,
                        content: values?.content,
                        attachments: files.map((m) => {
                            return {
                                fileName: m.name,
                                fileKey: m.key,
                                fileUrl: m.url,
                                type: m.type,
                            };
                        }),
                    });
                    if (res) {
                        formInstance?.reset();
                        setSubmitSuccess(true);
                    }
                }
                catch (err) {
                    logError(err, {
                        c2: 'submit feedback fail',
                    });
                    Message.error(err.message ||
                        err.errorMsg ||
                        $i18n.get({ id: 'CreationFailed', dm: '创建失败' }));
                }
                finally {
                    setIsSubmit(false);
                }
            }
        });
    };
    useEffect(() => {
        getBizTypeTrees({
            linkCode: feedbackCode,
            language: langCode,
            userId,
            userSystem,
            panelCode,
        }).then((res) => {
            if (!res) {
                return;
            }
            // 如果只有一个类型默认选中第一个
            // 只有一级 一个   或者 两级 各一个时 才默认 其他情况不默认
            const arr = parseTreeSelect(res);
            if (arr.length === 1) {
                let [defaultType] = arr;
                let defaultValue = defaultType?.value;
                if (defaultType?.children?.length === 1 ||
                    !defaultType?.children?.length) {
                    const [first] = defaultType?.children || [];
                    if (first) {
                        defaultType = first;
                        defaultValue = first.value;
                    }
                    setProblemType(defaultType);
                    field.setValue('problemType', `${defaultValue}`);
                }
            }
            setBizTree(parseTreeSelect(res));
        });
    }, []);
    const { form: formInstance, scheme, formConfig, hasMerchantCnMemberId, } = useWorkOrderForm({
        userId,
        userName,
        panelCode,
        accountType: userSystem,
        bizTypeId: field.getValue('problemType'),
        language: $i18n.getLang(),
    });
    useEffect(() => {
        if (formInstance && extraInfo) {
            formInstance.setValues(extraInfo);
        }
    }, [formInstance, extraInfo]);
    const prevContentTemplate = useRef();
    useEffect(() => {
        // 自动填写格式化指引的情况 1.  用户真的未填内容  2. 内容只是上一次的格式化
        if (!field.getValue('content') ||
            prevContentTemplate.current === field.getValue('content')) {
            field.setValue('content', formConfig?.contentTemplate);
        }
        // 缓存上一次的格式化指引
        prevContentTemplate.current = formConfig?.contentTemplate;
    }, [formConfig?.contentTemplate]);
    return (React.createElement("div", { className: `cn-ui-intelli-assistant-feedback` },
        React.createElement(Header, { onClick: linkCode ? null : onBack, title: $i18n.get({ id: 'FeedbackTitle', dm: '意见反馈' }) }),
        !submitSuccess ? (React.createElement("div", { className: 'cn-ui-intelli-assistant-feedback-body' },
            React.createElement("div", { className: 'cn-ui-intelli-assistant-feedback-content' },
                React.createElement("div", { className: 'cn-ui-intelli-assistant-feedback-title' },
                    $i18n.get({ id: 'FillInFeedbackInformation', dm: '提交反馈' }),
                    React.createElement("span", { className: 'cn-ui-intelli-assistant-feedback-title-record', onClick: () => {
                            gotoWorkOrder({ ...props, linkCode: feedbackCode });
                        } }, $i18n.get({ id: 'WorkOrderRecord', dm: '反馈列表' }))),
                React.createElement("div", { className: 'cn-ui-intelli-assistant-feedback-subtitle' }, $i18n.get({
                    id: 'YourFeedbackIsVeryImportantTo_2991559882',
                    dm: '您的反馈对我们非常重要，任何建议我们都会派发给负责人，持续完善我们的产品和服务体验',
                })),
                hasCaseType ? (React.createElement("div", { className: 'cn-ui-intelli-assistant-feedback-subtitle' },
                    $i18n.get({ id: 'YouCan', dm: '您可以' }),
                    React.createElement("span", { className: 'cn-ui-intelli-assistant-feedback-link', onClick: () => {
                            goGocPage(gocCaseUrl);
                            logCustom('CLK_go_goc_page', panelCode, gocCaseUrl);
                        } }, $i18n.get({ id: 'ClickHere', dm: '点此' })),
                    $i18n.get({
                        id: 'DirectlyInitiateTechnicalGOCWorkOrders_1588016893',
                        dm: '直接发起技术GOC工单；非技术问题，直接在本页面填写问题类型及描述',
                    }))) : null),
            React.createElement("div", { className: 'cn-ui-intelli-assistant-feedback-form' },
                React.createElement(Form, { field: field, labelAlign: 'top' },
                    React.createElement(Form.Item, { label: $i18n.get({ id: 'QuestionType', dm: '问题类型' }), required: true, requiredMessage: $i18n.get({
                            id: 'PleaseSelectTheQuestionType',
                            dm: '请选择问题类型',
                        }) },
                        React.createElement(CascaderSelect, { name: 'problemType', defaultValue: props.problemType || undefined, dataSource: bizTree, onChange: (v, data) => {
                                field.setValue('problemType', data.value);
                                setProblemType(data);
                            }, valueRender: (val) => {
                                return val?.fullName || undefined;
                            }, showSearch: true, placeholder: $i18n.get({ id: 'PleaseSelect', dm: '请选择' }), style: { width: '100%' } })),
                    React.createElement(Form.Item, { label: $i18n.get({
                            id: 'DetailedDescription.ued',
                            dm: '详细描述',
                        }), required: true, requiredMessage: $i18n.get({
                            id: 'PleaseFillInTheDetailedDescription_1268843601',
                            dm: '请填写详细描述',
                        }) },
                        React.createElement(Input.TextArea, { placeholder: $i18n.get({ id: 'PleaseEnter', dm: '请输入' }), name: 'content', defaultValue: props.content || undefined, maxLength: 500, showLimitHint: true, "aria-label": 'input max length 500', onPaste: (e) => {
                                const files = e.clipboardData?.files;
                                // @ts-ignore
                                files.length && uploadRef.current?.selectFiles?.(files);
                            } })),
                    hasMerchantCnMemberId ? React.createElement(Form.Item, { label: $i18n.get({ id: 'BusinessName', dm: '商家名称' }), required: true, requiredMessage: $i18n.get({
                            id: 'PleaseSelectTheQuestionType',
                            dm: '请选择商家名称',
                        }) },
                        React.createElement(CnAsyncSelect, { name: 'merchantCnMemberId', showSearch: true, requestConfig: {
                                // @ts-ignore
                                service: (merchantName) => {
                                    if (!merchantName) {
                                        return Promise.resolve([]);
                                    }
                                    return getCompanyList({
                                        merchantName,
                                        panelCode,
                                        currentPage: 1,
                                        pageSize: 20,
                                        userId,
                                        userName,
                                        accountType: userSystem,
                                    });
                                },
                            }, filterLocal: false, placeholder: $i18n.get({ id: 'PleaseSelect', dm: '请选择' }), style: { width: '100%' } })) : null,
                    problemType && formInstance ? (React.createElement(CnForm, { form: formInstance, schema: scheme })) : null,
                    React.createElement(Form.Item, { label: $i18n.get({ id: 'UploadAttachment', dm: '上传附件' }) },
                        React.createElement("div", { className: 'cn-ui-intelli-assistant-feedback-file-area' },
                            React.createElement("div", { className: 'cn-ui-intelli-assistant-feedback-record-btn' },
                                React.createElement(CnButton, { type: 'normal', onClick: () => {
                                        logCustom('CLK_upload_attachment', { userId, userSystem }, panelCode);
                                        uploadRef.current?.click();
                                    } },
                                    React.createElement(CnIcon, { type: 'upload' }),
                                    $i18n.get({ id: 'UploadAttachment', dm: '上传附件' })),
                                React.createElement(CnButton, { loading: snapshotVisible, onClick: async () => {
                                        logCustom('CLK_screen_shot', { userId, userSystem }, panelCode);
                                        await snapAuth();
                                        logCustom('OTHER_screen_shot_start', { userId, userSystem }, panelCode);
                                        setSnapshotVisible(true);
                                        startSnapshot()
                                            .then((res) => {
                                            // console.log('startSnapshot', res);
                                            uploadRef.current?.appendFiles([res]);
                                        })
                                            .catch((err) => {
                                            console.error(err);
                                        })
                                            .finally(() => {
                                            setSnapshotVisible(false);
                                        });
                                    } },
                                    React.createElement("img", { src: 'https://img.alicdn.com/imgextra/i1/O1CN015bA6Bo1QGgk2ZnT8D_!!6000000001949-55-tps-200-200.svg' }),
                                    $i18n.get({ id: 'ScreenCapture', dm: '截屏' })),
                                React.createElement(CnButton, { onClick: async () => {
                                        logCustom('CLK_screen_record', { userId, userSystem }, panelCode);
                                        await snapAuth();
                                        logCustom('OTHER_screen_record_start', { userId, userSystem }, panelCode);
                                        startRecord().then((res) => {
                                            const files = [
                                                {
                                                    name: `录屏-${recordNum++}.xreplay`,
                                                    key: res,
                                                    url: 'https://img.alicdn.com/imgextra/i2/O1CN01Jj3adP1K6G1diB7jF_!!6000000001114-2-tps-164-160.png',
                                                    type: 'video/xreplay',
                                                },
                                            ];
                                            // console.log('startRecord', res, files);
                                            uploadRef.current?.appendFiles(files);
                                        });
                                    } },
                                    React.createElement("img", { src: 'https://img.alicdn.com/imgextra/i2/O1CN01fAZAdf1pJJOuepfTl_!!6000000005339-55-tps-200-200.svg' }),
                                    $i18n.get({ id: 'RecordingScreen', dm: '录屏' }))),
                            snapTipVisible ? (React.createElement(CnMessage, { title: '', type: 'notice' },
                                $i18n.get({
                                    id: 'InOrderToBetterSolveYour_706171289',
                                    dm: '为了更好解决您的问题，系统将截取当前网页内容，是否允许截屏或录屏？',
                                }),
                                React.createElement(Row, { className: 'cn-ui-intelli-assistant-feedback-operate-btn-group' },
                                    React.createElement(Col, { offset: '8' },
                                        React.createElement(CnButton, { type: 'secondary', size: 'small', style: { marginRight: 10 }, onClick: () => agreeAuth(true) }, $i18n.get({ id: 'Allow', dm: '允许' })),
                                        React.createElement(CnButton, { type: 'normal', size: 'small', onClick: () => agreeAuth(false) }, $i18n.get({ id: 'NoThankYou', dm: '不了，谢谢' })))))) : null),
                        React.createElement(Upload, { ref: uploadRef, fileTitle: $i18n.get({
                                id: 'UploadAttachment',
                                dm: '上传附件',
                            }) })),
                    formConfig?.tipOpenVO?.value ? (React.createElement(Form.Item, { label: $i18n.get({
                            id: 'ServiceHelp',
                            dm: '服务帮助',
                        }) },
                        React.createElement(RichEditor, { content: formConfig?.tipOpenVO?.value, needRichEditor: true, canCopy: true, className: 'cn-ui-intelli-assistant-feedback-tip' }))) : null,
                    React.createElement(Form.Item, { label: ' ' },
                        React.createElement("div", { className: 'cn-ui-intelli-assistant-feedback-operate-btn-group' },
                            React.createElement(CnButton, { type: 'primary', style: { marginRight: 10 }, disabled: isSubmit, onClick: onFeedSubmit }, $i18n.get({ id: '31255239613091840.CNTM', dm: '提交' })),
                            React.createElement(CnButton, { type: 'normal', onClick: onBack }, $i18n.get({ id: 'Close', dm: '关闭' })))))))) : (React.createElement("div", { className: 'cn-ui-intelli-assistant-feedback-form-submit-success' },
            React.createElement(Result, { type: 'success', title: $i18n.get({ id: 'SubmissionCompleted.ued', dm: '成功' }), subTitle: $i18n.get({
                    id: 'ThankYouVeryMuchForYour_1751322811',
                    dm: '非常感谢您的反馈',
                }), extra: React.createElement(React.Fragment, null,
                    React.createElement(CnButton, { component: 'a', type: 'primary', style: { marginRight: 10 }, onClick: () => {
                            setSubmitSuccess(false);
                            field.reset();
                        } }, $i18n.get({ id: '31255238694539264.CNTM', dm: '返回' })),
                    React.createElement(CnButton, { component: 'a', type: 'normal', onClick: onClose }, $i18n.get({ id: 'Close', dm: '关闭' }))) })))));
}
